import { useLocalSearchParams } from 'expo-router';

import {
  ExpoRouterDemoBackButton,
  ExpoRouterDemoScreen,
  ExpoRouterDemoTitle,
} from '../../../../components';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  const { giftCardId } = useLocalSearchParams<{ giftCardId?: string[] }>();

  return (
    <ExpoRouterDemoScreen>
      <ExpoRouterDemoTitle>
        Account Gift Cards{giftCardId ? ` — ${giftCardId[0]}` : ''}
      </ExpoRouterDemoTitle>
      <ExpoRouterDemoBackButton />
    </ExpoRouterDemoScreen>
  );
}
